import styled, { css } from 'styled-components'

import { fadeSlideIn } from '@/theme/animations'

export const Wrapper = styled.div<{ $animate: boolean }>(
  ({ theme, $animate }) => css`
    /* Note: 'backwards', not 'both' - nothing is kept after the animation, so no leftover transform
       (a stacking context) interferes with drag and drop or popups inside the item */
    animation: ${$animate ? css`${fadeSlideIn} ${theme.transition.duration.md} ease-out backwards` : 'none'};

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `,
)
